import React, {  useEffect, useState } from "react";
import "../../../../i18n/i18n";
import { useTranslation } from "react-i18next";
import Image from "../../../../component/image/Image";
import { useDispatch, useSelector } from "react-redux";
import {
  useLocation,
  useNavigate,
  useParams,
} from "react-router-dom";
import {
  getJobDetails,
  getJobtemplateconfig,
  getQuestionList,
} from "../../../../redux/slices/careersSlices.reducer";
import { publishingDate } from "../CareersFucConfig";
import Model from "../../../../component/modal/Modal";
import OptionThreeJobView from "./OptionThreeJobView";
import useClientConfig from "../../../../config/careers/clientConfig";



const OptionThreeJobViewPage = (props: any) => {
  const { jobDataView, navigateToJob, getListOfJob } = props;
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const routeParams = useParams();
  const routerLocation = useLocation();
  const jobDetails = useSelector((state: any) => state.careers.jobDetails);
  const questionId = useSelector((stete: any) => { return stete?.careers?.getQuestionId; });
  const [jobModel, setJobModel] = useState(false);
  const [clientDesign, setClientDesign] = useState("");
  const cliendConfig = useSelector((state: any) => state.careers.cliendConfig);
  const SimilarJobList = jobDetails?.data?.data?.job?.similarJobs;
  const languageSettings = cliendConfig?.data?.data?.clientSettings?.languageSettings;
  const jobViewLangLabels = languageSettings?.jobView?.[0];
  const jobListingLangLabels = languageSettings?.jobListing?.[0];
  const {clientSiteSettings} = useClientConfig();
  const templateName = clientSiteSettings?.templateName;

  const checkClientDesign = () => {
    if(templateName === "template_4"){
      setClientDesign("template_4");
    } else if(templateName === "template_8"){
      setClientDesign("template_8_micro");
    } else if(templateName === "template_9"){
      setClientDesign("template_4");
    } else {
        setClientDesign("common");
    }

    if(clientSiteSettings?.optionThreeClient === true){
        setClientDesign("option3");
    }
  };

  useEffect(() => {
    if(!routerLocation.pathname.includes("/apply-job/")){
      document.body.classList.add("view-job-page");
      document.body.classList.remove("career-page");
      document.body.classList.remove("apply-job-page");
    }
  }, []);

  useEffect(() => {
      checkClientDesign();
  }, [routeParams, cliendConfig]);



  useEffect(() => {
    if (routerLocation.pathname === `/view/${routeParams?.id}`) {
      dispatch<any>(getJobtemplateconfig(cliendConfig?.data?.data?.clientSettings?.clientId));
      if(Object.keys(questionId).length === 0){
        dispatch<any>(getQuestionList());
      }
    }
  }, []);

  useEffect(() => {    
    if (routerLocation.pathname === `/view/${routeParams?.id}/apply-job/from/${routeParams?.from}`) {
      dispatch<any>(getJobDetails(routeParams?.id));
    }
  }, [routeParams?.id]);

  useEffect(() => {

    if (
      jobDetails?.data?.statusCode === 200 &&
      routerLocation?.pathname ===
      `/view/${routeParams?.id}`
    ) {
      if (navigator.userAgent.indexOf("Firefox") !== -1) {
        setTimeout(() => {
          window.scrollTo(0, 0);
        }, 1300);
      } else {
        window.scrollTo(0, 0);
      }
    }
  }, [routerLocation]);

  const jobDetailDownloadLink = () => {
    return (
      <>
        {(jobDetails?.data?.data?.job?.positionFile !== "" && jobDetails?.data?.data?.job?.positionFile !== null) ? (
          <span className="view-job-download-link-parent"><a className={`btn-new btn-primary-new ${"btn-new btn-primary-new"+ clientDesign === "template_4" ? "view-job-download-link text-primary" : "view-job-download-link text-primary"} `} href={jobDetails?.data?.data?.job?.positionFile} rel="noopener noreferrer" download target="_blank"> {jobViewLangLabels?.viewPositionDesc || "View Position Description"}</a></span> 
        ) : "" }
      </>
    );
  };

  // title
  const titleSection = () => {
    return (
      <div className="job-heading d-flex">
        <div className="job-heading-title">{jobDetails?.data?.data?.job.title}</div>
        {routerLocation.state !== "jobApply" ? (
          <div className="d-sm-block d-block d-md-none d-none">
            <i className="pi pi-star me-2 header-star"></i>
          </div>
        ) : (
          ""
        )}
        <div className="d-lg-flex d-md-flex  d-flex d-sm-flex align-items-center job-view-desc-sec">
          {jobDetailDownloadLink()}
        </div>
      </div>
    );
  };
  // description
  const description = () => {
    return (
        <div
          className="job-view-description"
          dangerouslySetInnerHTML={{
            __html: jobDetails?.data?.data?.job.description,
          }}
        >
        </div>
    );
  };


  const location = () => {
    return (
        <div className="d-flex">
          <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8.818 9.1475C9.82423 9.1475 10.6475 8.32423 10.6475 7.318C10.6475 6.31178 9.82423 5.4885 8.818 5.4885C7.81178 5.4885 6.9885 6.31178 6.9885 7.318C6.9885 8.32423 7.81178 9.1475 8.818 9.1475ZM8.818 0C12.66 0 16.136 2.9455 16.136 7.50095C16.136 10.4099 13.8949 13.831 9.42174 17.7736C9.07413 18.0755 8.55272 18.0755 8.20512 17.7736C3.74114 13.831 1.5 10.4099 1.5 7.50095C1.5 2.9455 4.97605 0 8.818 0Z" fill="#3A3E54"/></svg>
          <div className="add-start">            
            <span className="">
                {jobListingLangLabels?.location}: 
            </span>{" "}
            <span className="location">
               {jobDetails?.data?.data?.job?.location?.location}
            </span>
          </div>
        </div>
    );
  };
  const jobLogo = () => {
    let clientSettings = cliendConfig.data.data.clientSettings;
    let defaultJobLogo = "https://stag-compliance-careers.s3.ap-southeast-2.amazonaws.com/career-doc-settings/uploads/no_image.png";
    if(clientSiteSettings?.templateName === "template_4"){ 
      defaultJobLogo = cliendConfig.data.data.clientSettings.logo;
    }
    return (
      <div className="text-end">
        <Image
          src={
            jobDetails?.data?.data?.job?.logo
              ? jobDetails?.data?.data?.job?.logo
              : defaultJobLogo
          }
          width={100}
          
          alt="logo"
        />
      </div>
    );
  };

  const category = () => {
    return (
        <div className="d-flex">
        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M16.2 3.3H9L7.731 2.031C7.389 1.689 6.93 1.5 6.453 1.5H1.8C0.81 1.5 0.00899999 2.31 0.00899999 3.3L0 14.1C0 15.09 0.81 15.9 1.8 15.9H16.2C17.19 15.9 18 15.09 18 14.1V5.1C18 4.11 17.19 3.3 16.2 3.3ZM10.8 12.3H3.6V10.5H10.8V12.3ZM14.4 8.7H3.6V6.9H14.4V8.7Z" fill="#3A3E54"/></svg>
          <div className="add-start">
          <span className="">{jobViewLangLabels?.category}:</span>{" "}
            <span className="add-avalue">
              {" "}
              {jobDetails?.data?.data?.job?.category}
            </span>
          </div>
        </div>
    );
  };

  const referenceNo = () => {
    return (
        <div
          className={`d-flex ${routerLocation.state === "jobApply" ? "pt-2" : ""
            }`}
        >
          <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd" d="M12.8245 4.16252H16.2749L16.2752 4.1626C17.1754 4.1626 17.9063 4.89428 17.9063 5.7937V7.93157C17.9063 8.21282 17.6815 8.43767 17.4002 8.43767H10.0313V8.04362C10.0313 7.85612 9.88114 7.70597 9.69364 7.70597H8.30644C8.11893 7.70597 7.96879 7.85612 7.96879 8.04362V8.43767H0.59985C0.3186 8.43767 0.09375 8.21282 0.09375 7.93157V5.77532C0.09375 4.89347 0.8064 4.16252 1.70655 4.16252H5.1753V3.29972C5.1753 1.969 6.26212 0.881348 7.59367 0.881348H10.4062C11.7369 0.881348 12.8245 1.96817 12.8245 3.29972V4.16252ZM7.59345 2.68155C7.2558 2.68155 6.97455 2.9628 6.97455 3.30045L6.97447 4.16252L11.0248 4.16325V3.30045C11.0248 2.9628 10.7436 2.68155 10.4059 2.68155H7.59345ZM10.0119 9.37521H16.6872L16.6873 9.3751C16.9685 9.3751 17.1934 9.59995 17.1934 9.8812V14.7189C17.1934 15.619 16.4624 16.35 15.5623 16.35H2.4189C1.53705 16.35 0.806099 15.6373 0.806099 14.7372V9.88131C0.806099 9.60006 1.03095 9.37521 1.3122 9.37521H8.00576C8.06216 9.86226 8.47451 10.2563 8.99966 10.2563C9.52406 10.2563 9.95547 9.88131 10.0119 9.37521Z" fill="#3A3E54"/>
          </svg>
          <div className="add-start">            
            <span className="">
            {jobViewLangLabels?.jobReference}:
            </span>{" "}
            <span className="add-avalue">
               {jobDetails?.data?.data?.job?.referenceNo}
            </span>
          </div>
        </div>
    );
  };
  const postedOn = () => {
    return (
        <div className="d-flex">
        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
          <mask id="mask0_7398_35126" className="mask-style" maskUnits="userSpaceOnUse" x="0" y="0" width="18" height="18">
          <path fillRule="evenodd" clipRule="evenodd" d="M14.7275 1.63636H15.5456C16.4456 1.63636 17.182 2.37273 17.182 3.27273V16.3636C17.182 17.2636 16.4456 18 15.5456 18H2.45472C1.55472 18 0.818359 17.2636 0.818359 16.3636V3.27273C0.818359 2.37273 1.55472 1.63636 2.45472 1.63636H3.2729V0.818182C3.2729 0.368182 3.64109 0 4.09109 0C4.54109 0 4.90927 0.368182 4.90927 0.818182V1.63636H13.0911V0.818182C13.0911 0.368182 13.4593 0 13.9093 0C14.3593 0 14.7275 0.368182 14.7275 0.818182V1.63636ZM3.2729 16.3636H14.7275C15.1775 16.3636 15.5456 15.9955 15.5456 15.5455V5.72727H2.45472V15.5455C2.45472 15.9955 2.8229 16.3636 3.2729 16.3636Z" fill="white"/>
          </mask>
          <g mask="url(#mask0_7398_35126)">
          <rect width="18" height="18" fill="#3A3E54"/>
          </g>
        </svg>

          <div className="add-start">
          <span className="">{jobViewLangLabels?.posted}: </span>{" "}
            <span className="add-avalue">
              {publishingDate(jobDetails?.data?.data?.job?.postedAt)}
            </span>
          </div>
        </div>
    );
  };



  const positionType = () => {
    return (
        <div className="d-flex">
        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9 0C4.03579 0 0 4.03579 0 9C0 13.9642 4.03579 18 9 18C13.9642 18 18 13.9642 18 9C18 4.03579 13.9642 0 9 0ZM9 4.32C10.5347 4.32 11.7663 5.57053 11.7663 7.08632C11.7663 8.62105 10.5158 9.85263 9 9.85263C7.46526 9.85263 6.23368 8.60211 6.23368 7.08632C6.23368 5.57053 7.46526 4.32 9 4.32ZM9 10.7242C11.1221 10.7242 12.96 12.2021 13.7937 14.4189C12.5242 15.5558 10.8379 16.2379 9 16.2379C7.16211 16.2379 5.49474 15.5368 4.20632 14.4189C5.05895 12.2021 6.87789 10.7242 9 10.7242Z" fill="#3A3E54"/></svg>
          <div className="add-start">
            <span className=""> {jobViewLangLabels?.positionType}:</span>{" "}
            <span className="add-avalue">
              {jobDetails?.data?.data?.job?.jobType}
            </span>
          </div>
        </div>
    );
  };
  // ======================================
  const imgAndVideo = () => {
    return (
      <>
        {/* {routerLocation.state !== "jobApply" ? */}
        <div className="pt-2">
          {(jobDetails?.data?.data?.job?.videoLink !== "" && jobDetails?.data?.data?.job?.videoLink !== null) ? (
            <>
              <iframe width={ clientDesign === "template_4" ? "750" : "837" } height='315' src={jobDetails?.data?.data?.job?.videoLink} title='Your Career' frameBorder='0' allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share' allowFullScreen></iframe>
              {/* <div
                className="job-view-video"
                dangerouslySetInnerHTML={{
                  __html: jobDetails?.data?.data?.job?.videoLink,
                }}
              ></div> */}
            </>
          ) : (
            <>
              {(jobDetails?.data?.data?.job?.imageLink !== "" && jobDetails?.data?.data?.job?.imageLink !== null) ? (
               
                <Image width={ clientDesign === "template_4" ? "750" : "837" } height='315' src={jobDetails?.data?.data?.job?.imageLink} />
               
              ) : (
                ""
              )}
            </>
          )}
        </div>
        {/* : "" */}
        {/* } */}
      </>
    );
  };


  const navicateToApplayJob = () => {
    navigate(`/view/${routeParams?.id}/apply-job/from/direct`);
  };

  const BacktoSearchResult = () => {
    localStorage.setItem("backtoresult", "1");
    sessionStorage.setItem("backtoresult", "1");
    getListOfJob();
  };

  
  const ApplayNowButton = () => {
    return (
      <>
        {routerLocation.state !== "jobApply" ? (
            <div className="completion-btn-primary-parent">
              <button onClick={() => navicateToApplayJob()} className="job-apply-main-btn btn-new btn-primary-new w-100 justify-content-center">
                {t(cliendConfig?.data?.data?.clientSettings?.applyButtonText)}
              </button>

              { clientSiteSettings?.showBackToResultsBtn ? (
                <button onClick={() => BacktoSearchResult()} className="go-back-main-btn btn-new btn-primary-new w-100 justify-content-center">
                 {jobViewLangLabels?.backToResults}
                </button>
            ) : ""}
            </div>
        ) : (
          ""
        )}
      </>
    );
  };


  
  const listOfPoint = () => {
    return (
      <>
        {jobDetails?.data?.data?.job?.bulletPoint1 ||
          jobDetails?.data?.data?.job?.bulletPoint2 ||
          jobDetails?.data?.data?.job?.bulletPoint3 ? (
          <div>
            <ul className="list-style">
              {jobDetails?.data?.data?.job?.bulletPoint1 ? (
                <li>{jobDetails?.data?.data?.job?.bulletPoint1}</li>
              ) : (
                ""
              )}

              {jobDetails?.data?.data?.job?.bulletPoint2 ? (
                <li>{jobDetails?.data?.data?.job?.bulletPoint2}</li>
              ) : (
                ""
              )}

              {jobDetails?.data?.data?.job?.bulletPoint3 ? (
                <li>{jobDetails?.data?.data?.job?.bulletPoint3}</li>
              ) : (
                ""
              )}
            </ul>
          </div>
        ) : (
          ""
        )}
      </>
    );
  };


  const searchControlFilter = () => {
    setJobModel((prs) => (prs ? false : true));
  };
  const JobFilterBody = () => {
    return (
      <>
        <div className="model-close-icon">
          <i onClick={() => searchControlFilter()} className="pi pi-times"></i>
        </div>
        {jobDataView}
      </>
    );
  };

  

 

  //Resolves if the current client has a custom footer using the inbuilt clientids
    const hasCustomFooter = (id:any) => {
      return clientSiteSettings?.showFooter;
  };

  return (
    <>
   
      {jobDetails.status === 200 && jobDetails?.data?.statusCode === 200 ? (
        
        <OptionThreeJobView
            jobDataView = {jobDataView}
            routerLocation = {routerLocation}
            routeParams = {routeParams}
            titleSection = {titleSection} 
            jobLogo = {jobLogo}
            ApplayNowButton = {ApplayNowButton}
            listOfPoint = {listOfPoint}
            description = {description}
            imgAndVideo = {imgAndVideo}
            location = {location}
            referenceNo = {referenceNo}
            positionType = {positionType}
            category = {category}
            postedOn = {postedOn}
            clientDesign = {clientDesign}
            searchControlFilter = {searchControlFilter}
            // jobDetailDownloadLink = {jobDetailDownloadLink}
            navigateToJob = {navigateToJob}
            getListOfJob = {getListOfJob}
            similarJobList = {SimilarJobList}
            langSettings = {languageSettings}
          /> 
          
         
      ) : (
        <>
          {jobDetails?.data?.statusCode === 400 ? (
            <div className="card m-5">
              <div className="card-body text-center">
                {jobDetails?.data?.message}
              </div>
            </div>
          ) : (
            ""
          )}
        </>
      )}

      
      {/* {
      hasCustomFooter(cliendConfig?.data?.data?.clientSettings?.clientId) ? (
        <CareersCustomFooter clientSiteSettings={clientSiteSettings} />
      ) : null} */}

    
      <Model show={jobModel} size="lg" modelBody={JobFilterBody()} />
    </>
  );
};

export default OptionThreeJobViewPage;